import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    svgHover: {
        fill: theme.palette.foreground.default,
        "&:hover": {
            fill: theme.palette.primary.main,
        },
        transition: "all 0.5s ease",
    },
}));

export const Logo = () => {
    const classes = useStyles();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 400 400"
            className={classes.svgHover}
        >

<g transform="translate(0.000000,398.000000) scale(0.10000,-0.100000)"
 stroke="none">
    

    <path d="M1750 3740 c-397 -68 -717 -231 -997 -507 -346 -343 -533 -793 -533
-1286 0 -179 14 -294 55 -457 162 -637 672 -1147 1310 -1309 287 -73 613 -73
900 0 642 163 1152 674 1314 1314 72 286 72 614 0 897 -79 314 -249 611 -480
840 -282 278 -598 439 -1004 509 -146 25 -415 25 -565 -1z m-13 -777 c12 -8
29 -30 38 -50 25 -51 13 -99 -36 -144 -37 -34 -39 -39 -39 -95 0 -55 2 -60 30
-76 17 -10 38 -34 46 -54 57 -137 -131 -233 -212 -109 -21 32 -20 96 1 129 9
14 30 31 46 38 27 12 29 16 29 74 0 60 -1 63 -33 82 -47 27 -71 81 -58 130 23
85 115 122 188 75z m368 -14 c19 -17 35 -37 35 -45 0 -11 16 -14 64 -14 55 0
66 3 71 20 3 10 20 31 36 45 35 29 93 34 138 10 31 -15 61 -69 61 -108 0 -31
-38 -88 -70 -104 -55 -28 -138 -1 -162 52 -10 23 -17 25 -74 25 -52 0 -64 -3
-68 -18 -11 -35 -53 -64 -98 -69 -118 -13 -178 134 -87 211 45 38 107 36 154
-5z m3 -353 c32 -30 37 -40 37 -79 0 -50 -26 -95 -63 -112 -19 -9 -22 -18 -22
-75 1 -58 3 -67 26 -84 l26 -19 95 95 94 95 -21 36 c-29 49 -21 98 25 144 28
28 40 33 80 33 57 0 100 -23 120 -66 41 -86 -13 -173 -107 -174 -28 -1 -50
-17 -140 -103 -86 -82 -108 -108 -108 -130 0 -72 -60 -137 -126 -137 -47 0
-97 38 -112 87 -12 37 -11 46 6 86 13 30 30 49 51 58 30 13 31 16 31 76 0 59
-2 63 -29 78 -44 22 -61 53 -61 109 0 43 4 53 36 82 29 28 43 34 80 34 37 0
51 -6 82 -34z m-368 -355 c31 -22 56 -88 46 -125 -10 -40 -57 -83 -99 -91
-105 -20 -181 112 -111 194 42 51 110 59 164 22z m731 -17 c76 -73 22 -199
-86 -199 -81 0 -138 72 -116 145 28 94 131 122 202 54z m-1225 -480 c16 -64
-69 -298 -157 -433 l-23 -34 42 28 c58 39 92 30 92 -24 0 -53 -54 -135 -93
-139 -18 -2 -29 2 -33 13 -7 17 12 72 28 81 6 4 5 -3 -1 -14 -14 -25 -14 -52
-1 -52 12 0 56 77 64 113 10 42 -16 34 -62 -18 -34 -38 -42 -58 -53 -115 -13
-73 -18 -80 -40 -54 -10 13 -10 30 3 97 9 45 14 84 11 87 -2 2 -12 -1 -21 -7
-10 -6 -32 -14 -49 -17 -19 -5 -42 -21 -58 -42 -53 -69 -103 -24 -69 61 11 26
26 50 35 55 22 12 63 -11 67 -38 4 -24 11 -24 78 3 29 12 34 20 50 89 9 41 21
73 24 71 4 -2 5 7 2 22 -3 17 -1 24 6 19 6 -4 8 2 4 16 -4 16 -2 19 8 13 10
-6 12 -4 6 10 -9 24 32 137 47 128 6 -4 8 0 4 10 -3 10 -2 17 3 17 6 0 9 3 9
8 -3 20 2 32 13 26 7 -5 8 -3 4 5 -10 16 22 51 40 44 8 -3 17 -16 20 -29z
m450 -49 c-11 -69 -65 -246 -100 -327 -34 -78 -37 -117 -10 -139 19 -15 77 5
120 43 41 36 54 31 24 -9 -24 -33 -61 -57 -103 -67 -23 -6 -33 -1 -57 24 l-29
31 -17 -27 c-21 -31 -53 -45 -76 -32 -22 11 -23 47 -4 93 21 49 76 75 76 36 0
-26 -17 -36 -22 -14 -2 11 -11 -1 -21 -31 -9 -27 -14 -52 -11 -55 3 -3 18 9
34 27 21 25 29 48 34 95 17 153 90 383 130 409 22 14 38 -15 32 -57z m404
-189 c0 -2 -16 -28 -36 -57 -43 -65 -94 -163 -94 -183 0 -16 13 -14 95 11 28
9 52 19 55 23 3 4 15 10 27 14 18 6 22 4 17 -7 -6 -17 -67 -44 -158 -72 l-59
-18 36 -19 c44 -22 59 -47 63 -107 5 -81 -74 -193 -125 -176 -50 15 -63 99
-35 212 16 63 16 63 -8 83 l-23 19 25 1 c14 0 30 4 35 8 6 4 34 55 63 113 58
117 86 159 108 159 8 0 14 -2 14 -4z m470 -131 c0 -20 -114 -237 -129 -244
-31 -17 -45 10 -38 76 5 51 5 54 -9 35 -21 -31 -98 -74 -118 -66 -10 4 -16 18
-16 35 0 36 -10 36 -41 3 -53 -57 -99 -61 -99 -9 0 32 58 114 86 121 28 7 57
-13 50 -33 -3 -7 1 -13 9 -13 11 0 15 -11 15 -39 0 -36 2 -39 23 -33 49 12 89
47 112 97 12 26 14 27 21 12 3 -10 4 -46 1 -80 -3 -34 -2 -55 2 -47 64 123
105 190 117 190 7 0 14 -2 14 -5z m-1206 -38 c9 -15 5 -24 -27 -53 -21 -20
-44 -33 -52 -30 -16 6 -29 -24 -16 -37 9 -9 31 -4 116 27 16 6 15 4 -5 -13
-67 -57 -124 -64 -136 -16 -8 33 11 79 49 116 32 32 54 34 71 6z m1847 -21
c-25 -18 -64 -68 -107 -141 -15 -27 -34 -10 -34 31 0 19 -2 34 -5 34 -2 0 -21
-11 -41 -25 -49 -34 -69 -32 -91 8 -9 17 -13 15 -52 -17 -24 -20 -52 -36 -62
-36 -29 0 -44 41 -31 80 9 24 9 30 -1 26 -6 -2 -29 -10 -50 -17 -22 -7 -50
-27 -64 -46 -36 -47 -83 -40 -83 13 0 32 28 92 47 102 34 18 85 -21 66 -51 -4
-6 0 -8 9 -4 9 3 34 11 57 18 23 7 41 18 41 26 0 7 7 13 15 13 19 0 19 -2 -2
-66 -9 -30 -14 -57 -10 -60 4 -4 22 5 40 19 19 14 38 23 42 19 5 -4 5 -2 1 5
-8 14 29 37 44 28 6 -3 10 -15 10 -25 0 -10 4 -21 8 -24 13 -8 63 22 103 60
37 36 49 36 49 -3 0 -24 1 -24 27 8 28 32 81 61 96 52 5 -3 -5 -15 -22 -27z"/>

</g>
        </svg>
    );
};
